import { ApplicationRef, createComponent, EnvironmentInjector, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as userActions from '../../../../../aumico-lib-users-fe/src/lib/actions/user.actions';
import { AppState } from '../../state/app.state.reducer';
import { ReleaseHighlightsModalComponent } from '../components/release-highlights-modal/release-highlights-modal.component';
import { RELEASE_HIGHLIGHTS_CONFIG } from '../config/release-highlights.config';


@Injectable({
    providedIn: 'root',
})
export class ReleaseHighlightsService {
    private componentRef: any;

    constructor(
        private store: Store<AppState>,
        private appRef: ApplicationRef,
        private injector: EnvironmentInjector
    ) { }

    public showReleaseHighlights(userLastSeenReleaseId: string | undefined): void {

        if (userLastSeenReleaseId !== RELEASE_HIGHLIGHTS_CONFIG.releaseId) {
            this.showModal();
        }

    }

    private showModal(): void {
        this.componentRef = createComponent(ReleaseHighlightsModalComponent, {
            environmentInjector: this.injector,
        });

        document.body.appendChild(this.componentRef.location.nativeElement);
        this.appRef.attachView(this.componentRef.hostView);


        this.componentRef.instance.closeModal.subscribe(() => {
            this.updateLastSeenReleaseId();
            this.destroyModal();
        });
    }

    private destroyModal(): void {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }

    private updateLastSeenReleaseId(): void {

        this.store.dispatch(userActions.updateLastSeenReleaseId({ releaseId: RELEASE_HIGHLIGHTS_CONFIG.releaseId }));

    }
}
